import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, BaseDataService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { PodVrstaDokumentaStavka } from '../podvrste-dokumenta-stavka/podvrste-dokumenta-stavka';
import { TranslateService } from '@ngx-translate/core';
import { Osoba } from '../osoba/osoba';

@Component({
  selector: 'yt-podvrste-dokumenta-stavka-modal-update',
  templateUrl: './podvrste-dokumenta-stavka-modal-update.component.html'
})
export class PodVrsteDokumentaStavkaModalUpdateComponent
 extends BaseModalUpdateComponent<PodVrstaDokumentaStavka> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<PodVrstaDokumentaStavka>,
    protected activeModal: NgbActiveModal,
    protected translateService: TranslateService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected baseDataService: BaseDataService,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

 
  ngOnInit() {    
  }
  

}
